<template>
	<div
		class="resource-type"
		:class="[
			`resource-type-${type}`,
			{
				'resource-type-small': small,
				'resource-type-inverted': inverted,
			},
		]"
		:title="typeName"
	>
		<component
			:is="icon"
			class="icon"
		/>
	</div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import articleIconComponent from '@/images/resource-article.svg?component';
import videoIconComponent from '@/images/resource-video.svg?component';
import botIconComponent from '@/images/resource-bot.svg?component';
import { capitalise } from '@/helpers';
import { resourceTypeKeys, type ResourceTypeKey } from '@/interfaces/resourceFilterInterface';

export default defineComponent({
	props: {
		type: {
			type: String as PropType<ResourceTypeKey>,
			default: null,
		},
		small: {
			type: Boolean,
			default: false,
		},
		inverted: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		icon() {
			switch (this.type) {
				case resourceTypeKeys.Video:
					return videoIconComponent;
				case resourceTypeKeys.Bot:
					return botIconComponent;
				default:
					return articleIconComponent;
			}
		},
		typeName() {
			return capitalise(this.type);
		},
	},
});
</script>

<style scoped lang="scss">
@use '@/styles/utils';

.resource-type {
	display: flex;
	position: absolute;
	right: 10px;
	bottom: 10px;
	background-color: rgba(0 0 0 / 50%);
	padding: 3px 0;

	.icon {
		width: 30px;
		height: auto;
	}

	&.resource-type-video {
		right: 4px;
		padding: 1px 6px;
	}

	&.resource-type-bot {
		padding: 1px 3px;
	}

	&.resource-type-other-stuff {
		:deep() {
			svg {
				.icon-resource-article-bottom {
					display: none;
				}
			}
		}
	}

	&.resource-type-small {
		background-color: transparent;
		padding: 0;

		.icon {
			width: 18px;
		}

		&:not(.resource-type-bot) {
			:deep() {
				svg {
					* {
						fill: rgba(var(--rs-typography-font-body-color)) !important;
					}
				}
			}

			&.resource-type-inverted {
				:deep() {
					svg {
						* {
							fill: rgba(var(--rs-color-brand-white)) !important;
						}
					}
				}
			}
		}

		&.resource-type-bot:not(.resource-type-inverted) {
			:deep() {
				svg {
					* {
						stroke: rgba(var(--rs-typography-font-body-color)) !important;
					}
				}
			}
		}
	}
}
</style>
